import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { QuickBetConfig } from 'packages/sports/libs/common/client-config-data-access/src';
import { Observable, combineLatest, distinctUntilChanged, map, startWith } from 'rxjs';

import { selectQuickBetFreebetToken, selectQuickBetStakeState } from '../quick-bet.selectors';
import { QuickBetNumpadService } from './quick-bet-numpad.service';

@Injectable({ providedIn: 'root' })
export class QuickBetStakeStatusService {
    readonly isQuickBetStakeActive$: Observable<boolean>;

    constructor(quickBetNumpadService: QuickBetNumpadService, store: Store, quickBetConfig: QuickBetConfig) {
        this.isQuickBetStakeActive$ = combineLatest([
            quickBetNumpadService.quickBetNumpadOpen$,
            store.select(selectQuickBetFreebetToken),
            store.select(selectQuickBetStakeState),
        ]).pipe(
            map(([isNumpadOpen, freebetToken, stakeState]) => {
                const hasStake = !!+(stakeState.stake ?? '0');
                const hasFreebet = !!freebetToken;

                return !quickBetConfig.hideActionButtonsOnEmptyStake || hasStake || hasFreebet || isNumpadOpen;
            }),
            startWith(false),
            distinctUntilChanged(),
        );
    }
}
